import * as React from 'react';
import {observer} from 'mobx-react';
import {Form as IForm, FormField, FormFields} from '../types/form';
import {Form} from './form';
import {style} from 'typestyle';
import {px} from 'csx';

export interface PageCheckoutCouponCodeFields extends FormFields {
  couponCode: FormField<string>;
}

export type PageCheckoutCouponCodeModel = IForm<PageCheckoutCouponCodeFields>;

export interface PageCheckoutCouponCodeProps {
  model: PageCheckoutCouponCodeModel;
  onChange(couponCode: string): void;
}

@observer
export class PageCheckoutCouponCode extends React.Component<PageCheckoutCouponCodeProps, {}> {
  render() {
    const { onChange, model } = this.props;

    return (
      <Form
        className={PageCheckoutCouponCode.styles.form}
        model={model}
        onChange={(_, couponCode) => onChange(couponCode)}
        noButtons={true}
      />
    )
  }

  static styles = {
    form: style({
      maxWidth: px(640),
    })
  }
}